module.exports = __webpack_public_path__ + "img/bottomBanner.061cf347.png";